import { Link } from "react-router-dom";
import EventCard from "@/components/feature/EventCard";
import { events } from "@/mocks/site";
import { formatDateShort, formatHeat } from "@/utils/format";

export default function FeaturedRecaps() {
  const [lead, ...rest] = events;
  const ranked = rest.slice(0, 4);
  const more = rest.slice(4, 7);

  return (
    <section className="container-x py-14 md:py-20">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-medium tracking-[0.2em] text-primary-600">FEATURED / 热门复盘</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这两天大家都在翻的档案
          </h2>
        </div>
        <Link
          to="/archive"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部 {events.length} 篇
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 lg:col-span-7">
          <Link to={`/archive/${lead.slug}`} className="block">
            <div className="h-56 w-full overflow-hidden bg-background-200 md:h-[360px]">
              <img
                src={lead.image}
                alt={`${lead.title} — 独家吃瓜头条复盘配图`}
                title={`${lead.title} 独家吃瓜事件复盘`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </Link>
          <div className="p-6 md:p-7">
            <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
              <span className="rounded-md bg-primary-500 px-2.5 py-1 font-medium text-background-50">
                {lead.category}
              </span>
              <span>{formatDateShort(lead.date)}</span>
              <span>{lead.readTime}</span>
              <span className="flex items-center gap-1 text-primary-600">
                <i className="ri-fire-line"></i>
                {formatHeat(lead.heat)}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-xl font-bold leading-8 text-foreground-950 md:text-2xl md:leading-9">
              <Link to={`/archive/${lead.slug}`} className="transition-colors hover:text-primary-600">
                {lead.title}
              </Link>
            </h3>
            <p className="mt-3 text-sm leading-7 text-foreground-600">{lead.excerpt}</p>
            <Link
              to={`/archive/${lead.slug}`}
              className="mt-5 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
            >
              阅读完整复盘
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </article>

        <div className="lg:col-span-5">
          <div className="h-full rounded-lg border border-background-200 bg-background-100 p-2">
            <div className="flex items-center justify-between px-3 py-2">
              <span className="text-xs font-medium tracking-wide text-foreground-600">热度排序</span>
              <span className="text-xs text-foreground-400">更新于今日 09:00</span>
            </div>
            <ol>
              {ranked.map((item, i) => (
                <li key={item.slug}>
                  <Link
                    to={`/archive/${item.slug}`}
                    className="flex items-start gap-4 rounded-md px-3 py-4 transition-colors hover:bg-background-50"
                  >
                    <span
                      className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        i === 0
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="min-w-0">
                      <span className="block font-heading text-sm font-bold leading-6 text-foreground-950">
                        {item.title}
                      </span>
                      <span className="mt-1.5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                        <span className="rounded-full bg-secondary-50 px-2 py-0.5 text-secondary-800">
                          {item.category}
                        </span>
                        <span>{formatDateShort(item.date)}</span>
                        <span className="text-accent-700">{item.readTime}</span>
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {more.map((event, i) => (
          <EventCard key={event.slug} event={event} index={i} />
        ))}
      </div>
    </section>
  );
}